export const obavijest_ispitanicima= {
  templateId: 90.2,
  category: 9,
  templateTitle: "Informacije kod prikupljanja osobnih podataka",
  templateDescription: `U slučaju da se osobni podaci prikupljaju od ispitanika, voditelj obrade je dužan o tome, u  trenutku obrade ispitaniku pružiti informacije u skladu s Uredbom.`,
  description: `
    <h5>OPIS I SVRHA DOKUMENTA</h5>
    <p>Ako su osobni podaci koji se odnose na ispitanika prikupljeni od ispitanika, voditelj obrade u trenutku prikupljanja gore navedenih osobnih podataka ispitaniku pruža informacije navedene u Općoj uredbi o zaštiti podataka.</p>
    <p>Osim toga, kako bi se osigurala poštena i transparentna obrada voditelj obrade u trenutku kada se osobni podaci prikupljaju pruža ispitaniku i dodatne informacije navedene u Općoj uredbi o zaštiti podataka.</p>
     <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>UREDBA (EU) 2016/679 EUROPSKOG PARLAMENTA I VIJEĆA od 27. travnja 2016. o zaštiti pojedinaca u vezi s obradom osobnih podataka i o slobodnom kretanju takvih podataka te o stavljanju izvan snage Direktive 95/46/EZ (Opća uredba o zaštiti podataka).</p>
  `,
  
  sides: [
  {
    prefix: "Na temelju Opće uredbe o zaštiti podataka,",
    signature: "Voditelj obrade:",
  	inputs:[{ 
      type: "input", 
      required: true, 
      placeholder: "Ime i prezime",
      label: "Ime i prezime",
      inSignature: true,
    },
    { 
      type: "input", 
      required: true, 
      placeholder: "Ulica i kućni broj",
    },
    { 
      type: "input", 
      required: true, 
      placeholder: "Mjesto",
    },
    { 
      type: "input", 
      required: true, 
      placeholder: "OIB",
    },
    ],
    suffix: " (u daljnjem tekstu: Voditelj obrade),"
  }
  ],
    
  headline: "daje sljedeće",
  title: "INFORMACIJE KOD PRIKUPLJANJA OSOBNIH PODATAKA",

  noArticleNumbers: true,

  articles: [
    {
      title: '',
      mandatory: true,
      exampleContent: true,
      dummy: true, 
      statements: [
        {
          type: 'text',
          mandatory: true,
          editable: false,
          content: 'Prema Općoj uredbi o zaštiti podataka, Voditelj obrade o vama',
      },
      {
        type: 'text',
        required: true,
        mandatory: true,
        editable: true,
        help: 'Upisati kategoriju ispitanika, npr. radnicima i sl.',
        content: ' ',
    },
    {
      type: 'text',
      mandatory: true,
      editable: false,
      content: ' prikuplja i obrađuje neke ili sve od sljedećih osobnih podataka, i to:\r\n',
  },
      {
        type: 'text',
        required: true,
        mandatory: true,
        editable: true,
        content: '- ime i prezime,\r\n- adresu, \r\n- osobni identifikacijski broj i/ili drugi identifikacijski broj,\r\n- datum rođenja / JMBG, \r\n- osobni broj iz e-radne knjižice,\r\n- broj tekućeg ili žiro-računa,\r\n- dokaz o završenom školovanju (svjedodžba, diploma i sl.), \r\n- uvjerenje o zdravstvenoj sposobnosti i sl.,\r\npreduvjet za sklapanje i izvršenje Ugovora o radu odnosno svih obveza iz radnog odnosa te je navedene podatke u tom smislu Radnik pružio Poslodavcu. \r\nRadnik svojim potpisom na ovoj Izjavi potvrđuje da mu je Poslodavac dostavio informacije koje je dužan dostaviti u trenutku prikupljanja gore navedenih osobnih podataka, a prema Općoj uredbi o zaštiti podataka i to:\r\n- identitet i kontaktne podatke voditelja obrade odnosno predstavnika voditelja obrade, \r\n- svrhe obrade radi kojih se upotrebljavaju osobni podaci, kao i pravnu osnovu za obradu, \r\n- primatelje ili kategorije primatelja osobnih podataka, \r\n- razdoblje u kojem će osobni podaci biti pohranjeni ili, ako to nije moguće, kriterije kojima se utvrdilo to razdoblje, \r\n- postojanje prava da se od voditelja obrade zatraži pristup osobnim podacima i ispravak ili brisanje osobnih podataka ili ograničavanje obrade koji se odnose na ispitanika ili prava na ulaganje prigovora na obradu takvih te prava na prenosivost podataka, \r\n- pravo na podnošenje prigovora nadzornom tijelu.',   help: 'Ovdje unosite kategorije osobnih podataka koje obrađuje voditelj obrade. Prethodno uneseno je samo dano radi primjera.',
        value: '',
      },
    ],
    value: '',
}, 
  {
    title: "",
    mandatory: true,
    dummy: true,
    statements: [
      {
        type: "input",
        mandatory: true,
        parts: [
          { type: "text", content: "Voditelj obrade," },
          { type: "input", content: "", required: true,  placeholder: "Poslovni subjekt"},
          { type: "text", content: "," },
          { type: "input", content: "", required: true,  placeholder: "Ulica i kućni broj"},
          { type: "text", content: "," },
          { type: "input", content: "", required: true,  placeholder: "Mjesto"},
          { type: "text", content: "," },
          { type: 'text', content: 'OIB:' },
          { type: "input",  required: true,},
          { type: "text", content: "," },
          { type: "text", content: " obrađuje osobne podatke, a u ime voditelja obrade osobne podatke obrađuje zaposlenik Voditelja obrade," },
          { type: "input", content: "", required: true,  placeholder: "Ime i prezime"},
          { type: "text", content: "," },
          { type: "input", content: "", required: true,  placeholder: "Ulica i kućni broj"},
          { type: "text", content: "," },
          { type: "input", content: "", required: true,  placeholder: "Mjesto"},
          { type: "text", content: "," },
          { type: 'text', content: 'OIB:' },
          { type: "input",  required: true,},
          { type: "text", content: "," },
          { type: "input",  required: true,  placeholder: "kontakt e-mail ili telefon."},
        ],
          },
        ]
      },
      {
        title: '',
        mandatory: true,
        dummy: true, 
        exampleContent: true,
        statements: [
            {
                type: 'text',
                required: true,
                mandatory: true,
                editable: false,
                content: 'Pravna osnova obrade: ',
                value: '',
            },
            {
                type: 'text',
                required: true,
                mandatory: true,
                editable: true,
                content: 'zakonske obveze voditelja obrade.',
                value: '',
            },
        ],
        value: '',
    },
  {
    title: '',
    mandatory: true,
    dummy: true, 
    exampleContent: true,
    statements: [
        {
            type: 'text',
            required: true,
            mandatory: true,
            editable: false,
            content: 'Svrha obrade: ',
            value: '',
        },
        {
            type: 'text',
            required: true,
            mandatory: true,
            editable: true,
            content: 'ispunjenje zakonskih obveza voditelja obrade.',
            value: '',
        },
    ],
    value: '',
},
{
  title: '',
  mandatory: true,
  dummy: true, 
  exampleContent: true,
  statements: [
      {
          type: 'text',
          required: true,
          mandatory: true,
          editable: false,
          content: 'Primatelji osobnih informacija su:\r\n',
          value: '',
      },
      {
          type: 'text',
          required: true,
          mandatory: true,
          editable: true,
          content: '- Hrvatski zavod za mirovinsko osiguranje,\r\n- Hrvatski zavod za zdravstveno osiguranje, \r\n- Ministarstvo financija - Porezna uprava,\r\n- Hrvatski zavod za zapošljavanje, \r\n- FINA,\r\n- poslovne banke, \r\nte svi drugi primatelji kojima je Voditelj obrade dužan predati osobne podatke sukladno zakonskim obvezama koja reguliraju radne odnose, ovršni postupak, obvezama  izvješćivanja o primitcima zaposlenika, pravima i obvezama iz područja osiguranja te svim drugim zakonskim obvezama Voditelja obrade.',
          value: '',
      },
  ],
  value: '',
}, 
{
  title: "",
  mandatory: false,
  dummy: true,
  statements: [
    {
      type: "input",
      mandatory: true,
      parts: [
        { type: "text", content: "Također, primatelj osobnih podataka, a ujedno i izvršitelj obrade osobnih podataka je " },
        { type: "input", content: "", required: true,  placeholder: "Poslovni subjekt"},
        { type: "text", content: "," },
        { type: "input", content: "", required: true,  placeholder: "Ulica i kućni broj"},
        { type: "text", content: "," },
        { type: "input", content: "", required: true,  placeholder: "Mjesto"},
        { type: "text", content: "," },
        { type: 'text', content: 'OIB:' },
        { type: "input",  required: true,},
        { type: "text", content: "," },
        { type: "text", content: "a u slučaju da dođe do eventualne promjene izvršitelja obrade o tome ćemo vas obavijestiti." },
      ],
        },
      ]
    },
    {
      title: '',
      mandatory: true,
      dummy: true, 
      exampleContent: true,
      statements: [
          {
              type: 'text',
              required: true,
              mandatory: true,
              editable: true,
              content: 'Prikupljeni osobni podaci se uslijed zakonskih obveza čuvaju trajno.\r\nOsobni podaci nalaze se u kod gore navedenog izvršitelja obrade ili kod Voditelja obrade.\r\nSvim ostalim stranama ovi podaci se neće dostavljati, a u slučaju da budu zatraženi od neke treće strane, prosljeđivat će se samo uz izričitu pisanu privolu ispitanika.',
              value: '',
          },
      ],
      value: '',
  },
  {
    title: '',
    mandatory: true,
    dummy: true, 
    exampleContent: true,
    statements: [
        {
            type: 'text',
            required: true,
            mandatory: true,
            editable: false,
            content: 'U vezi osobnih podataka imate sljedeća prava:\r\n',
            value: '',
        },
        {
            type: 'text',
            required: true,
            mandatory: true,
            editable: true,
            content: '- zatražiti pristup osobnim podacima,\r\n- ispravak ili brisanje osobnih podataka,\r\n- ograničavanje obrade podataka koji se odnose na ispitanika,\r\n- prigovora  na obradu podataka,\r\n- prenosivost podataka,,\r\n- prigovora nadzornom tijelu, \r\nali samo u onoj mjeri kojom se ne krše obveze zakonskih propisa iz područja obračuna poreza, zakona o rokovima čuvanja dokumentacije i sl..',
            value: '',
        },
    ],
    value: '',
  }, 
  {
    title: '',
    mandatory: true,
    dummy: true, 
    exampleContent: true,
    statements: [
        {
            type: 'text',
            required: true,
            mandatory: true,
            editable: true,
            content: 'Svojim potpisom potvrđujete da ste obaviješteni o načinu prikupljanja, obujmu prikupljenih podataka, korištenju i obradi osobnih podataka te da ste s postupanjem na ovakav način suglasni.',
            value: '',
        },
    ],
    value: '',
},
{
  title: '',
  mandatory: true,
  dummy: true, 
  exampleContent: true,
  statements: [
      {
          type: 'text',
          required: true,
          mandatory: true,
          editable: true,
          content: 'Također, svojim potpisom na ovoj Obavijesti potvrđujete da su vam uručeni i obrasci za ostvarivanje prava (pristup osobnim podacima, ispravak ili brisanje osobnih podataka, ograničavanje obrade koji se odnose na ispitanika,  prigovora, prenosivost podataka).',
          value: '',
      },
  ],
  value: '',
},
  {
    mandatory: true,
    static: true,
    type: 2, // date and place
    statements: [
      {
        type: "input",
        mandatory: true,
        parts: [
          {
            type: "text",
            content: "U"
          },
          {
            type: "input",
            value: "",
            placeholder: "Upišite mjesto.",
            required: true,
          },
          {
            type: "text",
            content: ", dana"
          },
          {
            type: "date",
            value: new Date(),
            required: true
          },
          {
            type: "text",
            content: "godine."
          }
        ]
      },
    ]
  },
  {
    mandatory: true,
    static: true,
    type: 3,  // signatures   
    statements: [],
  },
  {
    static: true,
    mandatory: true,
    type: 4, 
    statements: [
      {
        type: "input",
        mandatory: true,
        editable: false,
        parts: [
          { type: "text", content: "\r\nIspitanik svojim potpisom potvrđuje primitak ove Obavijesti dana ________________ godine." }
          
        ]
      },
      {
        type: "text",
        mandatory: true,
        editable: false,
        content: "\r\nIspitanik: ________________________."
      }
      ],
    },
],
};


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/90.2_obavijest_ispitanicima.ts